// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { 
//   getUserLocation, 
//   reRequestLocationPermission,
//   selectLocation, 
//   selectPermissionStatus,
//   selectLocationError,
//   selectLocationLoading
// } from 'store/features/locationSlice';

// const LocationComponent = () => {
//   const dispatch = useDispatch();
//   const locationState = useSelector((state) => state.location);
//   console.log("🚀 ~ LocationComponent ~ locationState:", locationState)

//   const location = useSelector(selectLocation);
//   const permissionStatus = useSelector(selectPermissionStatus);
//   const error = useSelector(selectLocationError);
//   const isLoading = useSelector(selectLocationLoading);

//   useEffect(() => {
//     dispatch(getUserLocation());
//   }, [dispatch]);

//   const handleReRequestPermission = () => {
//     dispatch(reRequestLocationPermission());
//   };

//   if (isLoading) {
//     return <div>Loading location...</div>;
//   }

// //   if (error) {
// //     return <div>Error: {error}</div>;
// //   }

//   return (
//     <div>
//       <p>Permission status: {permissionStatus}</p>
//       {location?.latitude && location?.longitude ? (
//         <p>
//           Your location: {location?.latitude}, {location?.longitude}
//         </p>
//       ) : (
//         <p>Location not available</p>
//       )}
//       {permissionStatus === 'denied' && (
//         <button onClick={handleReRequestPermission}>
//           Allow Location Access
//         </button>
//       )}
//     </div>
//   );
// };

// export default LocationComponent;


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTimeZone from 'hooks/useTimeZone';

import { 
  getUserLocation, 
  reRequestLocationPermission,
  selectLocation, 
  selectPermissionStatus,
  selectLocationError,
  selectLocationLoading,
  selectShowManualInstructions,
  setShowManualInstructions
} from 'store/features/locationSlice';

const LocationComponent = () => {
  const dispatch = useDispatch();
  const location = useSelector(selectLocation);
  const permissionStatus = useSelector(selectPermissionStatus);
  const error = useSelector(selectLocationError);
  const isLoading = useSelector(selectLocationLoading);
  const showManualInstructions = useSelector(selectShowManualInstructions);

  useEffect(() => {
    dispatch(getUserLocation());
  }, [dispatch]);

  const handleReRequestPermission = () => {
    dispatch(reRequestLocationPermission());
  };

  const handleCloseInstructions = () => {
    dispatch(setShowManualInstructions(false));
  };

  // if (isLoading) {
  //   return <div>Loading location...</div>;
  // }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

  // return (
  //   <div>
  //     <p>Permission status: {permissionStatus}</p>
  //     {location.latitude && location.longitude ? (
  //       <p>
  //         Your location: {location.latitude}, {location.longitude}
  //       </p>
  //     ) : (
  //       <p>Location not available</p>
  //     )}
  //     {permissionStatus === 'denied' && (
  //       <button onClick={handleReRequestPermission}>
  //         Allow Location Access
  //       </button>
  //     )}
  //     {showManualInstructions && (
  //       <div>
  //         <h3>How to enable location access:</h3>
  //         <ol>
  //           <li>Click the lock icon (or info icon) in your browser's address bar</li>
  //           <li>Find the "Location" or "Site settings" option</li>
  //           <li>Change the setting to "Allow"</li>
  //           <li>Refresh the page and try again</li>
  //         </ol>
  //         <button onClick={handleCloseInstructions}>Close Instructions</button>
  //       </div>
  //     )}
  //   </div>
  // );

  return (
    <>
    </>
  );
};

export default LocationComponent;